import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import MetalRateStrip from '../components/MetalRateStrip';
import OnboardingModal from '../components/OnboardingModal';

const TermsPage = () => {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authModalRole, setAuthModalRole] = useState('buyer');

  const openAuth = (role) => {
    setAuthModalRole(role);
    setAuthModalOpen(true);
  };

  return (
    <div className="app-wrapper">
      <MetalRateStrip />
      <Navbar onOpenAuthModal={openAuth} />

      <main style={{ padding: '60px 0 80px 0' }}>
        <div className="jmi-container" style={{ maxWidth: '900px' }}>
          <div className="section-header-center">
            <div className="section-label">LEGAL & REGULATORY</div>
            <h1 className="section-title">
              Terms of <span className="gold-gradient-text">B2B Trade & Custody</span>
            </h1>
            <p className="section-subtitle">
              Last updated: 2026. Standard governing rules for commercial jewellery procurement, settlement, and transit.
            </p>
          </div>

          <div className="jmi-card" style={{ display: 'flex', flexDirection: 'column', gap: '24px', lineHeight: '1.7', color: 'var(--text-secondary)' }}>
            <div>
              <h3 style={{ color: '#FFFFFF', marginBottom: '8px' }}>1. Scope & Network Participation</h3>
              <p>
                Jewel Mart India ("JMI"), operated by 7RAYS GLOBAL PRIVATE LIMITED (CIN: U47733GJ2026PTC171774), Surat, Gujarat, 395010 - India, functions solely as an institutional B2B operating 
                network for registered commercial enterprises in the gems and jewellery sector. Direct retail consumers are 
                strictly excluded from onboarding and transactional participation.
              </p>
            </div>

            <div>
              <h3 style={{ color: '#FFFFFF', marginBottom: '8px' }}>2. Hallmarking & Purity Standards</h3>
              <p>
                All gold jewellery transactions must comply with mandatory Bureau of Indian Standards (BIS) hallmarking 
                regulations including six-digit alphanumeric HUID (Hallmark Unique Identification). Silver articles must 
                satisfy BIS 925 / 999 standards. Discrepancies exceeding authorized assay tolerances invoke operator intervention 
                and penalty protocols.
              </p>
            </div>

            <div>
              <h3 style={{ color: '#FFFFFF', marginBottom: '8px' }}>3. Bullion Price Locking Mechanics</h3>
              <p>
                Quoted bullion rates are pegged to real-time market benchmark feeds with regional commercial adjustments. 
                Upon mutual acceptance of an order, the metal rate is irrevocably locked. Fluctuations occurring after 
                timestamped order confirmation do not alter the contractual wholesale invoice amount.
              </p>
            </div>

            <div>
              <h3 style={{ color: '#FFFFFF', marginBottom: '8px' }}>4. Transit, Custody & Insurance</h3>
              <p>
                Consignments moving through JMI certified logistics partners are packed in serialized, tamper-evident security bags 
                and covered by transit insurance up to the declared valuation. Custody transfers require OTP authentication 
                between authorized personnel at all logistics nodes.
              </p>
            </div>

            <div>
              <h3 style={{ color: '#FFFFFF', marginBottom: '8px' }}>5. Cancellation & Refunds</h3>
              <p>
                Due to market volatility in precious metals, confirmed customized casting and fabricated jewellery orders 
                cannot be unilaterally cancelled once fabrication begins. Faulty or non-specification items verified at the 
                operator hub will be returned to the seller with full escrow refund to the buyer.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer onOpenAuthModal={openAuth} />
      <OnboardingModal 
        isOpen={authModalOpen} 
        onClose={() => setAuthModalOpen(false)} 
        initialRole={authModalRole} 
      />
    </div>
  );
};

export default TermsPage;
